import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
import Dialog from '../Dialog';

interface MarkCompleteDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const MarkCompleteDialog: React.FC<MarkCompleteDialogProps> = ({
    isOpen,
    onClose,
    onConfirm
}) => {
    return (
        <Dialog
            id="mark-complete-dialog"
            isOpen={isOpen}
            onClose={onClose}
            width="w-[450px]"
            padding="px-10 py-10"
            className="z-[60]"
            hideCloseButton={true}
            disableBackdropClick={true}
        >
            <div className="text-center">
                <div className="flex justify-center mb-4">
                    <div className="bg-white flex items-center justify-center mx-auto mb-4">
                        <AlertCircleIcon className="w-16 h-16 text-[#FF2C23]" />
                    </div>
                </div>
                <h3 className="text-heading font-heading mb-2">Confirmation</h3>
                <p className="text-text-secondary mb-8">
                    Are you sure this jobsite is completed and no further work is pending?
                </p>

                <div className="flex justify-center gap-4">
                    <button
                        id="btn-mark-complete-cancel"
                        onClick={onClose}
                        className="btn-secondary px-8 py-2"
                    >
                        No
                    </button>
                    <button
                        id="btn-mark-complete-confirm"
                        onClick={onConfirm}
                        className="btn-primary px-8 py-2"
                    >
                        Yes
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default MarkCompleteDialog; 